import gql from 'graphql-tag';

const MUTATION_EXPORT_CONTACTABILITY_REPORT = gql`
    mutation exportContactabilityReport( $filters: FilterInputContactabilityReport $sendToExport: String ) {
        exportContactabilityReport(
        filters: $filters
        sendToExport: $sendToExport
        ) {
            internalCode
        }
    }
`;

export default MUTATION_EXPORT_CONTACTABILITY_REPORT;
